const PtlIcon = () => (
	<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect width="400" height="400" fill="white"/>
	<rect x="24" y="20" width="18" height="361" rx="9" fill="#4F4F4F"/>
	<circle cx="33.5" cy="200.5" r="30.5" fill="#FF6726"/>
	<path d="M101.263 108.111C107.238 96.3838 119.287 89 132.449 89H360C379.33 89 395 104.67 395 124V277C395 296.33 379.33 312 360 312H131.334C118.762 312 107.156 305.257 100.929 294.335L60.3514 223.166C54.5147 212.929 54.2214 200.441 59.571 189.941L101.263 108.111Z" fill="#FF6726"/>
	<g clip-path="url(#clip0_2_25)">
	<path d="M164.641 248.383V149.516H195.461V161.937H180.734V235.922H195.461V248.383H164.641ZM264.953 147.25L239.172 243.031H224.836L250.617 147.25H264.953ZM325.148 149.516V248.383H294.328V235.922H309.055V161.937H294.328V149.516H325.148Z" fill="white"/>
	</g>
	<defs>
	<clipPath id="clip0_2_25">
	<rect width="175" height="175" fill="white" transform="translate(153 97)"/>
	</clipPath>
	</defs>
	</svg>); 
export default PtlIcon;
